// Environment-based configuration

// API configuration
const API_CONFIG = {
  baseUrl: process.env.REACT_APP_API_URL || 'http://localhost:8081',
  endpoints: {
    chat: '/api/chat/send'
  }
};

// Export configurations
export { API_CONFIG };
